export const NOT_AVAILABLE = "-";

export const INVITATION_CODE = "invitation-code" as const;
